export const whitespaceRegex = /^\s*$/;

// for doc and pdf
export const acceptTypes =
  '.doc,.docx,.pdf,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
